import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import QueryRenderer from 'relay-query-lookup-renderer';
import serverVars from 'server-vars';
import ReactDOM from 'react-dom';

import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { ContemporaryLandingRespLayout } from '../contemporaryLanding/ContemporaryLandingRespLayout';
import { contemporaryLandingRootQuery } from '../queries/contemporaryLandingRoot';
import { ContemporaryLandingContextProvider } from '../contemporaryLanding/ContemporaryLandingContext';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { defaultLocale } from 'dibs-intl/exports/constants';

initializeDBL().then(() => {
    if ('ReactIntlLocaleData' in window) {
        const locale = serverVars.get('localeDataKey');
        addLocaleData(window.ReactIntlLocaleData[locale]);
    }

    const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

    ReactDOM.hydrate(
        <IntlProvider
            locale={serverVars.get('locale')}
            defaultLocale={defaultLocale}
            messages={serverVars.get('messages')}
        >
            <ContemporaryLandingContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
                userType={serverVars.get('userType')}
            >
                <QueryRenderer
                    lookup
                    query={contemporaryLandingRootQuery}
                    variables={serverVars.get('relayVariables')}
                    environment={environment}
                    render={({ error, props }) => {
                        if (error) {
                            return <Error500Layout />;
                        }

                        return <ContemporaryLandingRespLayout {...props} />;
                    }}
                />
            </ContemporaryLandingContextProvider>
        </IntlProvider>,
        document.getElementById('js-root')
    );
});
